import { Center, Text3D } from '@react-three/drei'
import { animated } from '@react-spring/three'
import { useAtomValue } from 'jotai'
import { languageAtom } from '../GlobalState'
import translations from '../dictionaries/translations'

export default function MinigameTimeAlert({ scale = 1, position = [0, 0, 0] }) {
  const language = useAtomValue(languageAtom)
  const fontUrl = language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json"

  return <animated.group scale={scale} position={position}>
    <mesh castShadow receiveShadow scale={[2.6, 0.055, 2]}>
      <cylinderGeometry args={[1, 1, 1, 64]} />
      <meshStandardMaterial color='black' opacity={0.8} transparent />
    </mesh>
    <Center position={[0, 0.2, 0]}>
      <Text3D font={fontUrl} rotation={[Math.PI / 2, Math.PI, Math.PI]} size={0.58} height={0.01} lineHeight={0.8}>
        {translations.minigames.timeAlert[language]}
        <meshStandardMaterial color='yellow' />
      </Text3D>
    </Center>
  </animated.group>
}
